import { GenericService } from './generic.service';
import { User } from '@/models';

export class UsersService extends GenericService<User> {

  constructor() {
    super('v1/users');
  }
}
